import React, { useState } from "react";
import { useDispatch } from "react-redux";

import RemoveAlert from "../../common/RemoveAlert";
import InputField from "../../common/forms/InputField";
import Checkin from "./Checkin";
import MinifiedCheckin from "./MinifiedCheckin";
import { editCheckin, deleteCheckin } from "../../../redux/checkins/actions";

export default function EditableCheckin({ data, date, minified = false }) {
  const [editing, setEditing] = useState(false);
  const dispatch = useDispatch();

  const handlePatch = (values) => {
    dispatch(editCheckin({ id: data.id, ...values }));
  };

  const handleChangeStatus = (e) => {
    handlePatch({ finished: e.target.checked });
  };

  const handleDelete = () =>
    RemoveAlert({
      customTitle: "Você tem certeza que deseja remover este checkin?",
      continueCallback: () => dispatch(deleteCheckin(data.id)),
    });

  const handleBlur = (e) => {
    if (e.target.value.length > 0 && e.target.value !== data.title)
      handlePatch({ title: e.target.value });

    setEditing(false);
  };

  const handleEnter = (e) => {
    if (e.keyCode === 13) e.target.blur();
  };

  return (
    <div className="d:f a-i:c">
      {editing ? (
        <InputField
          defaultValue={data.title}
          onBlur={handleBlur}
          autoFocus
          onKeyUp={handleEnter}
          maxLength={150}
        />
      ) : minified ? (
        <MinifiedCheckin
          data={data}
          date={date}
          setEditing={setEditing}
          handlePatch={handlePatch}
          handleDelete={handleDelete}
          handleChangeStatus={handleChangeStatus}
        />
      ) : (
        <Checkin
          data={data}
          setEditing={setEditing}
          handlePatch={handlePatch}
          handleDelete={handleDelete}
          handleChangeStatus={handleChangeStatus}
        />
      )}
    </div>
  );
}
